/**
 * Public URL of a file in the asset bucket, same rule as the backend's
 * `AssetService::url()`: CDN + `assets/` + path.
 *
 * Most endpoints already send absolute URLs, but some payloads carry the raw
 * stored path — `GET /user/getUser` nests `players[].tribe.icon` as
 * `tribes/roman_icon.png`. An absolute URL (or a `data:`/`blob:` one) passes
 * through untouched, so it is safe to call on either.
 */
const CDN_BASE = (import.meta.env.VITE_CDN_URL || 'https://cdn-test.travick.app').replace(/\/$/, '')

export function assetUrl(path: string | null | undefined): string | null {
  const trimmed = path?.trim()
  if (!trimmed) return null
  if (/^(https?:)?\/\//i.test(trimmed) || /^(data|blob):/i.test(trimmed)) return trimmed
  return `${CDN_BASE}/assets/${trimmed.replace(/^\/+/, '')}`
}
